<template>
  <Dropdown
    v-model="selectedCompany"
    filter
    :options="formattedCompanies"
    optionLabel="formattedLabel"
    placeholder="Seleccionar compañia"
    class="w-full mt-3"
    tooltip="Elegir un cliente"
    showClear
    v-on:change="setCompany"
    :pt="{
      input: 'ellipsis-text',
    }"
  >
    <template #value="slotProps">
      <div v-if="slotProps.value" class="flex align-items-center">
        <div>{{ slotProps.value.code }}-{{ slotProps.value.name }}</div>
      </div>
      <span v-else>
        {{ slotProps.placeholder }}
      </span>
    </template>
    <template #option="slotProps">
      <div class="flex align-items-center">
        <div>{{ slotProps.option.code }}-{{ slotProps.option.name }}</div>
      </div>
    </template>
  </Dropdown>
</template>
<script setup lang="ts">
  import useCompany from '@/store/company'
  import { computed, onMounted, ref } from 'vue'
  import useCompanies from '../composables/useCompanies'
  import { useUserStore } from '@/store'
  import { storeToRefs } from 'pinia'

  const companyStore = useCompany()
  const selectedCompany = ref()
  const companies = ref()
  const userStore = useUserStore()
  const { user } = storeToRefs(userStore)

  companyStore.$subscribe(async (_, state) => {
    selectedCompany.value = state.company
  })

  onMounted(async () => {
    selectedCompany.value = companyStore.company
    const { companies: Companies } = await useCompanies()
    companies.value = Companies.value
  })

  const setCompany = () => {
    const company = selectedCompany.value
      ? {
          code: selectedCompany.value.code,
          id: selectedCompany.value.id,
          name: selectedCompany.value.name,
          companyId: selectedCompany.value.companyId,
          client: selectedCompany.value.client,
        }
      : null

    companyStore.setCompany(company)
  }

  const formattedCompanies = computed(() => {
    return companies.value?.map((company: any) => ({
      ...company,
      formattedLabel: `${company?.code}-${company?.name}`,
    }))
  })

  const isSuperAdmin = computed(() =>
    user.value?.roles.name === 'superadmin' ? true : false
  )
</script>
<style scoped>
  .ellipsis-te {
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    overflow: hidden !important;
  }

  /**p-dropdown-label p-inputtext p-placeholder */
</style>
